var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPopover
    ? _c(
        "b-popover",
        {
          ref: "calendarPopover",
          attrs: {
            "custom-class": "calendar-popover",
            triggers: "manual",
            placement: "right",
            boundary: "window",
            target: _vm.eventTargetElement,
            show: _vm.showPopover,
          },
          on: { hidden: _vm.handleHidden },
        },
        [
          _vm.loading
            ? _c("calendar-popover-loader")
            : _c("calendar-event-information", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.hide,
                    expression: "hide",
                  },
                ],
                attrs: {
                  "event-details": _vm.eventDetails,
                  "start-time": _vm.startTime,
                  "end-time": _vm.endTime,
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }